import React from 'react';
import styles from './Navbar.module.css';
import Logo from './Logo';

interface NavbarProps {
  isDarkMode: boolean;
  onThemeToggle: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ isDarkMode, onThemeToggle }) => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
      <div className={styles.logoSection}>
        <Logo />
      </div>
        
        <div className={styles.navLinks}>
          <button onClick={onThemeToggle} className={styles.themeToggle}>
            {isDarkMode ? "☀️" : "🌙"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;